module.exports = __webpack_public_path__ + "static/img/yytx05.b41d392.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx05.png
// module id = 785
// module chunks = 0